/**
 * Vazio · carregando · erro — os três estados que a 11.1 e a 11.2 declaram.
 *
 * O esqueleto existe porque a alternativa (lista vazia enquanto carrega) mostra um fato
 * financeiro falso: "R$ 0,00" e "nenhuma campanha" são afirmações, e nenhuma das duas é
 * verdade enquanto o pedido está no ar.
 */
import type { ReactNode } from 'react'
import { Inbox, RefreshCw } from 'lucide-react'
import { mensagemDe, type TipoDeFalha } from '../api/erros.js'

/** O vazio do protótipo: o ícone num ladrilho de 44px, o título e a frase (PK-09). */
export function Vazio({ titulo, texto, icone = <Inbox size={20} /> }: { titulo: string; texto: string; icone?: ReactNode }) {
  return (
    <div className="vazio" role="status">
      <span className="vazio-icone" aria-hidden="true">{icone}</span>
      <strong>{titulo}</strong>
      <p>{texto}</p>
    </div>
  )
}

export function Erro({ tipo, tentar }: { tipo: TipoDeFalha; tentar: () => void }) {
  return (
    <div className="erro erro-bloco" role="alert">
      <strong>{mensagemDe(tipo)}</strong>
      <button onClick={tentar}>
        <RefreshCw size={16} /> Tentar de novo
      </button>
    </div>
  )
}

/** A FORMA do que vem, não um "carregando…" no meio da tela (spec 04-TELAS/0.3 §11). */
export function Esqueleto({ linhas = 3, teste }: { linhas?: number; teste?: string }) {
  return (
    <div
      className="esqueleto"
      role="status"
      aria-busy="true"
      {...(teste === undefined ? {} : { 'data-teste': teste })}
    >
      <span className="sr-only">Carregando…</span>
      {Array.from({ length: linhas }, (_, indice) => (
        <span key={indice} className="esqueleto-linha" aria-hidden="true" />
      ))}
    </div>
  )
}
